const identificationTypes = [
  'Drivers Licence',
  'Electoral Card',
  'International Passport',
  'PID'
];
export default identificationTypes;
